module.exports = __webpack_public_path__ + "iconmonstr-facebook-1-48.png?195d24b79f93c971f2b9194e9bbf5d88";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/iconmonstr-facebook-1-48.png
// module id = 88
// module chunks = 0